import { render, staticRenderFns } from "./EventRegistered.vue?vue&type=template&id=0cf2bf51"
import script from "./EventRegistered.vue?vue&type=script&lang=js"
export * from "./EventRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports